export class SignalRNotificationStatusConst {
  public static IN_PROGRESS_NOTIFICATION = "in_progress";
  public static FAILED_NOTIFICATION = "failed";
  public static SUCCESS_NOTIFICATION = "success";
}
